import { ContainerJourneyHistoryPage as PlanningContainerJourneyHistoryPage } from '@tom-ui/planning'
import { cargoUnitService } from 'modules/operations/src/services'
import { useCallback } from 'react'

export const ContainerJourneyHistoryPage = () => {
  const fetchOpsAdditionalData = useCallback(async (gangIds: number[], shiftIds: number[]) => {
    const data = await cargoUnitService.getContainerHistoryAdditionalData(gangIds, shiftIds)
    return {
      gangs: data.gangs,
      shifts: data.shifts,
    }
  }, [])

  return <PlanningContainerJourneyHistoryPage fetchOpsAdditionalData={fetchOpsAdditionalData} />
}

export default ContainerJourneyHistoryPage
